module.exports = __webpack_public_path__ + "static/media/duedate.51c28e95.svg";